module.exports = __webpack_public_path__ + "static/media/econometric.bba27586.pdf";